import React from 'react'

const SectionBenefit = () => {
  return (
    <>
  {/* Benefit Section */}
  <section className="section benefit-section bg-light-300">
    <div className="container">
      <div className="row justify-content-center">
        <div
          className="col-lg-6 text-center aos"
         data-aos="fade-up"
        >
          <div className="section-header text-center">
            <h2 className="mb-2">
              Our{" "}
              <span className="text-primary  text-decoration-underline">
                Benefits
              </span>{" "}
              &amp; Key Advantages
            </h2>
            <p className="sub-title">
              Trio International, a tour operator specializing in dream destinations,
              offers a variety of benefits for travelers.
            </p>
          </div>
        </div>
      </div>
      <div className="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4">
        <div className="col d-flex">
          <div
            className="card benefit-card mb-0 flex-fill aos"
           data-aos="fade-up"
          >
            <div className="card-body text-center">
              <div className="benefit-icon mb-2 bg-secondary text-gray-9 mx-auto">
                <i className="isax isax-lock-1" />
              </div>
              <h5 className="mb-2">Expert Guidance</h5>
              {/* <p className="mb-0">
                Include premium seating, meet-and-greet experiences, backstage
                tours.
              </p> */}
            </div>
          </div>
        </div>
        <div className="col d-flex">
          <div
            className="card benefit-card mb-0 flex-fill aos"
           data-aos="fade-up"
          >
            <div className="card-body text-center">
              <div className="benefit-icon mb-2 bg-orange text-white mx-auto">
                <i className="isax isax-magicpen" />
              </div>
              <h5 className="mb-2">Exceptional Customer Service</h5>
              {/* <p className="mb-0">
                A centralized place to buy tickets for various dates of the tour
              </p> */}
            </div>
          </div>
        </div>
        <div className="col d-flex">
          <div
            className="card benefit-card mb-0 flex-fill aos"
            data-aos="fade-up"
          >
            <div className="card-body text-center">
              <div className="benefit-icon mb-2 bg-purple text-white mx-auto">
                <i className="isax isax-receipt-add" />
              </div>
              <h5 className="mb-2">Personalized Itineraries</h5>
              {/* <p className="mb-0">
                Bundles that include concert tickets, accommodations
              </p> */}
            </div>
          </div>
        </div>
        <div className="col d-flex">
          <div
            className="card benefit-card mb-0 flex-fill aos"
            data-aos="fade-up"
          >
            <div className="card-body text-center">
              <div className="benefit-icon mb-2 bg-blue text-white mx-auto">
                <i className="isax isax-airplane me-2" />
              </div>
              <h5 className="mb-2">Effortless Travel Experience</h5>
              {/* <p className="mb-0">
                Such as private rehearsals, soundcheck access,
              </p> */}
            </div>
          </div>
        </div>
        <div className="col d-flex">
          <div
            className="card benefit-card mb-0 flex-fill aos"
            data-aos="fade-up"
          >
            <div className="card-body text-center">
              <div className="benefit-icon mb-2 bg-teal text-white mx-auto">
                <i className="isax isax-location-tick" />
              </div>
              <h5 className="mb-2">Safety and Reliability</h5>
              {/* <p className="mb-0">
                Such as private rehearsals, soundcheck access,
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* /Benefit Section */}
</>

  )
}

export default SectionBenefit